
    import './styles.scoped.css';
    export default {
  "header-cell": "awsui_header-cell_1spae_uinnl_9",
  "header-cell-fake-focus": "awsui_header-cell-fake-focus_1spae_uinnl_43",
  "header-cell-group": "awsui_header-cell-group_1spae_uinnl_64",
  "header-cell-grouped": "awsui_header-cell-grouped_1spae_uinnl_64",
  "header-cell-spans-rows": "awsui_header-cell-spans-rows_1spae_uinnl_64",
  "resize-divider": "awsui_resize-divider_1spae_uinnl_69",
  "header-cell-sticky": "awsui_header-cell-sticky_1spae_uinnl_72",
  "header-cell-stuck": "awsui_header-cell-stuck_1spae_uinnl_78",
  "header-cell-variant-full-page": "awsui_header-cell-variant-full-page_1spae_uinnl_78",
  "header-cell-hidden": "awsui_header-cell-hidden_1spae_uinnl_84",
  "header-cell-variant-embedded": "awsui_header-cell-variant-embedded_1spae_uinnl_87",
  "is-visual-refresh": "awsui_is-visual-refresh_1spae_uinnl_87",
  "sticky-cell": "awsui_sticky-cell_1spae_uinnl_87",
  "header-cell-variant-borderless": "awsui_header-cell-variant-borderless_1spae_uinnl_87",
  "header-cell-sortable": "awsui_header-cell-sortable_1spae_uinnl_90",
  "table-variant-full-page": "awsui_table-variant-full-page_1spae_uinnl_111",
  "sticky-cell-pad-left": "awsui_sticky-cell-pad-left_1spae_uinnl_114",
  "has-selection": "awsui_has-selection_1spae_uinnl_114",
  "sticky-cell-last-inline-start": "awsui_sticky-cell-last-inline-start_1spae_uinnl_117",
  "sticky-cell-last-inline-end": "awsui_sticky-cell-last-inline-end_1spae_uinnl_129",
  "sorting-icon": "awsui_sorting-icon_1spae_uinnl_138",
  "header-cell-main": "awsui_header-cell-main_1spae_uinnl_146",
  "sort-priority-badge": "awsui_sort-priority-badge_1spae_uinnl_151",
  "edit-icon": "awsui_edit-icon_1spae_uinnl_155",
  "header-cell-content": "awsui_header-cell-content_1spae_uinnl_161",
  "header-cell-content-expandable": "awsui_header-cell-content-expandable_1spae_uinnl_167",
  "header-cell-content-multi-sorted": "awsui_header-cell-content-multi-sorted_1spae_uinnl_225",
  "header-cell-disabled": "awsui_header-cell-disabled_1spae_uinnl_228",
  "header-cell-sorted": "awsui_header-cell-sorted_1spae_uinnl_228",
  "header-cell-main-with-menu": "awsui_header-cell-main-with-menu_1spae_uinnl_232",
  "header-cell-content-with-menu": "awsui_header-cell-content-with-menu_1spae_uinnl_237",
  "header-cell-text": "awsui_header-cell-text_1spae_uinnl_269",
  "header-cell-text-wrap": "awsui_header-cell-text-wrap_1spae_uinnl_273",
  "header-cell-ascending": "awsui_header-cell-ascending_1spae_uinnl_279",
  "header-cell-descending": "awsui_header-cell-descending_1spae_uinnl_280",
  "with-paddings": "awsui_with-paddings_1spae_uinnl_394",
  "has-striped-rows": "awsui_has-striped-rows_1spae_uinnl_394",
  "sticky-cell-pad-inline-start": "awsui_sticky-cell-pad-inline-start_1spae_uinnl_394",
  "header-cell-resizable": "awsui_header-cell-resizable_1spae_uinnl_406"
};
  